import CircleProgressLib from 'js-circle-progress';

class circleProgress {
  constructor(context) {
    context.querySelectorAll('[data-circle-max]').forEach(element => {
      const baseDate = element.dataset.circleValue - 3600;
      let reloadInProgress = element.dataset.circleValue == '100';
      const circleProgress = new CircleProgressLib(element, {
        max: (element.dataset.circleMax - baseDate),
        value: (element.dataset.circleValue - baseDate),
        textFormat: function (value, max) {
          var textTemplate = element.dataset.circleText;
          var delta = max - value;

          if (delta <= 0 && !reloadInProgress) {
            reloadInProgress = true,
            window.location.reload();
          }

          var days = Math.floor(delta / 86400);
          delta -= days * 86400;
          var hours = Math.floor(delta / 3600);
          delta -= hours * 3600;
          var minutes = Math.floor(delta / 60) % 60;
          delta -= minutes * 60;
          var seconds = delta % 60;
          textTemplate = textTemplate.replace('@days', days);
          textTemplate = textTemplate.replace('@hours', hours);
          textTemplate = textTemplate.replace('@minutes', minutes);
          textTemplate = textTemplate.replace('@seconds', seconds);
          element.querySelector('.circle-progress__text').innerHTML = textTemplate;
          return '';
        }
      });
      setInterval(() => {
        circleProgress.value = Math.floor(Date.now() / 1000) - baseDate;
      }, 1000);
    });
  }
};

export default circleProgress;